import {gql} from "@apollo/client";

export const CreateRiskAssessmentReport = gql`
    mutation CreateRiskAssessmentReport($input: RiskAssessmentReportAttributesInput!) {
        createRiskAssessmentReport(input: $input) {
            id
            title
            status
        }
    }
`;
